import React from 'react';
import { Link } from 'react-router-dom'
import Bg1 from '../../images/shapes/it_solution_hero_bg_1.svg'
import Bg2 from '../../images/hero/it_solution_hero_image_2.webp'
import heroImg from '../../images/hero/it_solution_hero_image_1.webp'
import icon from '../../images/icons/icon_stars_trustpilot.svg'
import avatar1 from '../../images/avatar/avatar_1.webp'
import avatar2 from '../../images/avatar/avatar_2.webp'
import avatar3 from '../../images/avatar/avatar_3.webp'
import blankimg from '../../images/blank_img.png'
import hero_top from '../../images/hero_top.png'

const Hero = () => {

    return (
        <section className="it_solution_hero_section">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6">
                        <div className="it_solution_hero_content_new">
                            <img src={hero_top} />
                            <h1>
                               Hotel Software That <br/> Puts you in control
                            </h1>
                            <p>
                               All-in-one software that helps you take charge of your operations and <span>unlock more revenue.</span>
                            </p>
                            <ul className="unordered_list p-0 justify-content-start">
                                <li>
                                    <Link className="btn" to="/pricing">
                                        <span className="btn_label" data-text="Try Free For 14 Days">Try Free For 14 Days</span>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-6">
                      <img src={blankimg} alt="Techco - Trustpilot Review" />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Hero;